import { z } from 'zod';

export const SceneManipulationSettingsSchema = z
  .object({
    discardAnimations: z.boolean().optional(),
    rotateZUp: z.boolean().optional(),
    centerModel: z.boolean().optional(),
    removeInvisibleGeometry: z.boolean().optional(),
    removeSmallFeatures: z
      .object({
        removalCount: z.number().gte(0).optional(),
        removalPercentage: z.number().gte(0).lte(100).optional(),
      })
      .optional(),
  })
  .optional();
